export default __webpack_public_path__ + "7a5cb30819db358a1cd983c23cf72ed8.svg";